// extracted by mini-css-extract-plugin
export default {"privateModeSwitch":"xYbBbBc6gabpH6lnnz3c"};